import { render } from "./GridMetricas.vue?vue&type=template&id=36853f70&scoped=true"
import script from "./GridMetricas.vue?vue&type=script&lang=js"
export * from "./GridMetricas.vue?vue&type=script&lang=js"

import "./GridMetricas.vue?vue&type=style&index=0&id=36853f70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36853f70"]])

export default __exports__